import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SingleRecording } from '../../../queries/ats/recordings/types/recording';
import { details } from '../../../routes/routes';
import PlayerAssetCard from '../UI/PlayerAssetCard';

interface RecordingPlayerCardProps {
  recording: SingleRecording;
}

export function RecordingPlayerCard({ recording }: RecordingPlayerCardProps) {
  const history = useHistory();
  const shouldHideControls = useSelector((state) => state.app.shouldFadeOut);

  if (shouldHideControls) {
    return null;
  }

  return (
    <PlayerAssetCard
      image={recording.image}
      currentTitle={recording.name}
      currentSeason={recording.type === 'linked' ? recording.season.sequenceNumber.toString() : undefined}
      currentEpisode={recording.type === 'linked' ? recording.episode.sequenceNumber.toString() : undefined}
      showDetailsPanel={() => {
        history.push(
          details.path({
            id: recording.programId,
            type: 'recording',
            subType: 'single',
            params: {
              orderByProviderId: recording.channelId,
              platformTitleId: recording.programId,
            },
          }),
        );
      }}
    />
  );
}
